import { Group } from '@repletoryreach/sdk-ui';
import { SegmentedControl } from '@repletoryreach/sdk-ui/inputs';
import { useT } from '../../../i18n/I18nProvider';

export type RangeOption = '1h' | '24h' | '7d' | '30d';

export const RANGE_OPTIONS: RangeOption[] = ['1h', '24h', '7d', '30d'];

const TO_MS: Record<RangeOption, number> = {
  '1h': 60 * 60_000,
  '24h': 24 * 60 * 60_000,
  '7d': 7 * 24 * 60 * 60_000,
  '30d': 30 * 24 * 60 * 60_000
};

export function rangeToSinceIso(range: RangeOption): string {
  return new Date(Date.now() - TO_MS[range]).toISOString();
}

/**
 * The relative window every audit-style feed is read through. The group is
 * labelled because the control's purpose is otherwise only inferable from the
 * option text, which a screen reader reaches after the fact.
 */
export function RangePicker({ value, onChange }: { value: RangeOption; onChange: (v: RangeOption) => void }) {
  const t = useT();
  return (
    <Group gap="sm" role="group" aria-label={t('audit.range.label')}>
      <SegmentedControl
        data={RANGE_OPTIONS.map((r) => ({ value: r, label: t(`audit.range.${r}`) }))}
        value={value}
        onChange={(v) => onChange(v as RangeOption)}
      />
    </Group>
  );
}
